import { render } from "./advisorDetailItem.vue?vue&type=template&id=55ba60d0"
import script from "./advisorDetailItem.vue?vue&type=script&lang=js"
export * from "./advisorDetailItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__